import React, { useEffect, useRef, useState } from "react";
import { IQuizObjectChunk } from "../../../../../../store/modquiz/quiz_objects/quiz-object/quiz-object-chunk";
import TextField from "@mui/material/TextField";
import { observer } from "mobx-react";

import { Link } from "react-router-dom";

import ContentEditable from "react-contenteditable";
import ChunkTypeMenu from "./TypeMenu";

interface ChunkProps {
    chunk: IQuizObjectChunk;
    focusField: Function;
    blurField: (event: React.FocusEvent<HTMLDivElement>) => void;
    addChunk: Function;
    focusNextField: Function;
    focusPreviousField: Function;
    focusOn: number | undefined;
    thisIndex: number;
    subjectHashKey: string;
}

function getTag(content: string) {
    if (content.startsWith("######")) return "h6";
    if (content.startsWith("#####"))  return "h5";
    if (content.startsWith("####"))   return "h4";
    if (content.startsWith("###"))    return "h3";
    if (content.startsWith("##"))     return "h2";
    if (content.startsWith("#"))      return "h1";
    return "p";
}

function chunkClasses(chunkType: string) {
    if (chunkType == "card" || chunkType == "link") {
        return "chunk-link"
    }
}

const Chunk = observer(
    ({
        chunk,
        focusField,
        blurField,
        addChunk,
        focusNextField,
        focusPreviousField,
        focusOn,
        thisIndex,
        subjectHashKey,
    }: ChunkProps) => {
        let [htmlTag, setHtmlTag] = useState(getTag(chunk.content));

        let lastKey: string | null = "";

        let handleChunkChange = (ev: any) => {
            chunk.setContent(ev.target.value);
        };

        let handleTypeChange = (typeValue: string) => {
            chunk.setType(typeValue);
        };


        const inputRef = useRef<HTMLDivElement>(null);

        useEffect(() => {
            if (focusOn === thisIndex) {
                inputRef.current && inputRef.current.focus();
            }
        });

        const handleChunkKeyDown = (
            ev: React.KeyboardEvent<HTMLDivElement>,
            text: string,
        ): boolean => {
            /*
             * If the user uses "Enter" then add a new chunk.  This should only happen if
             * you are already on the last row.  Above that it should insert a new chunk
             * between othr chunks.
             */
            if (ev.key === "Enter") {
                ev.preventDefault();
                addChunk();
                focusNextField();
                return false;
            }

            if (ev.key === "ArrowUp") {
                ev.preventDefault();
                return focusPreviousField();
            }

            if (ev.key === "ArrowDown") {
                ev.preventDefault();
                return focusNextField();
            }

            setHtmlTag(getTag(text));
            return true;
        };

        const handleChunkKeyUp = (
            ev: React.KeyboardEvent<HTMLDivElement>,
            text: string
        ): void => {
            if (ev.key == "Backspace") {
                ev.preventDefault();
                // If the field was empty before then delete.
                if (lastKey == "" && ev.currentTarget.textContent == "") {
                    chunk.remove();
                }
                lastKey = ev.currentTarget.textContent || "";
            }
        };

        if (chunk.chunkType == "link" || chunk.chunkType == "card") {
            return (
                <div>
                    <ChunkTypeMenu chunkType={chunk.chunkType} handleTypeChange={handleTypeChange} showMenu={!!(chunk._id && chunk._id.length === 24)}/>
                    <Link to={`/subjects/${subjectHashKey}/o/${chunk.linkedCardID}`}>
                    <ContentEditable
                        innerRef={inputRef}
                        html={chunk.content} // innerHTML of the editable div
                        disabled={false} // use true to disable editing
                        onBlur={blurField}
                        onChange={handleChunkChange} // handle innerHTML change
                        className={"chunk-graph " + chunkClasses(chunk.chunkType)}
                        tagName={htmlTag} // Use a custom HTML tag (uses a div by default)
                        onKeyUp={ev => {
                            handleChunkKeyUp(ev, chunk.content);
                        }}
                        onKeyDown={ev => {
                            handleChunkKeyDown(ev, chunk.content);
                        }}
                    />
                    </Link>
                </div>);
        }
        return (
            <div>
                <ChunkTypeMenu chunkType={chunk.chunkType} handleTypeChange={handleTypeChange} showMenu={!!(chunk._id && chunk._id.length === 24)}/>
                <ContentEditable
                    innerRef={inputRef}
                    html={chunk.content} // innerHTML of the editable div
                    disabled={false} // use true to disable editing
                    onBlur={blurField}
                    onChange={handleChunkChange} // handle innerHTML change
                    className={"chunk-graph " + chunkClasses(chunk.chunkType)}
                    tagName={htmlTag} // Use a custom HTML tag (uses a div by default)
                    onKeyUp={ev => {
                        handleChunkKeyUp(ev, chunk.content);
                    }}
                    onKeyDown={ev => {
                        handleChunkKeyDown(ev, chunk.content);
                    }}
                />
            </div>
        );
    }
);

export default Chunk;
